

export function getPddFromTemplate(stepCode: string) {
  if (stepCode === 'tdf_drdopdd') {
    return `<h2 style="text-align: center; line-height: 1;"><strong><span style="text-decoration: underline;"><span style="font-size: 18px;">FORM&ndash;3.0&nbsp;</span></span></strong></h2>
    <h2 style="line-height: 1; text-align: center;"><span style="text-decoration: underline;"><span style="font-size: 18px;"><strong>(PART&ndash;II A)</strong></span></span></h2>
    <h2 style="line-height: 1; text-align: center;"><span style="text-decoration: underline;"><span style="font-size: 18px;"><strong>PROJECT DEFINITION DOCUMENT (PDD)</strong></span></span></h2>
    <h2 style="line-height: 1; text-align: center;"><span style="text-decoration: underline;"><span style="font-size: 18px;"><strong>DETAIL TECHNICAL SPECIFICATION</strong></span></span></h2>
    <hr>
    <h3><strong>1. Problem / Requirements</strong></h3>
    <table style="width: 100.06%; height: 379.444px; border-collapse: collapse; border-style: inset; border-spacing: 10px;" border="0">
    <thead>
    <tr style="height: 65px;">
    <th style="width: 100.008%; text-align: left; padding: 15px;" colspan="2">
    <h4><span style="font-size: 14px;"><strong>(A) Details&nbsp;</strong><strong>Description of Project </strong><strong>Requirement</strong></span></h4>
    </th>
    </tr>
    </thead>
    <tbody>
    <tr style="height: 88.2222px;">
    <td style="width: 6.4015%; text-align: right; padding: 15px;">(i)</td>
    <td style="width: 93.6069%; padding: 15px;">
    <p>Describe the problem / Requirement (Please Explain)</p>
    <p>&nbsp;</p>
    </td>
    </tr>
    <tr style="height: 88.2222px;">
    <td style="width: 6.4015%; text-align: right; padding: 15px;">(ii)</td>
    <td style="width: 93.6069%; padding: 15px;">
    <p>Logical Diagram for explaining the problem</p>
    <p>&nbsp;</p>
    </td>
    </tr>
    <tr style="height: 40.1944px;">
    <td style="width: 6.4015%; text-align: right; padding: 15px;">(iii)</td>
    <td style="width: 93.6069%; padding: 15px;">List of Critical Technologies involved in the project requirement</td>
    </tr>
    <tr style="height: 40.1944px;">
    <td style="width: 6.4015%; text-align: right; padding: 15px;">(iv)</td>
    <td style="width: 93.6069%; padding: 15px;">System Requirement &amp; its description (Interrelationship of the solution with Full system, if any)</td>
    </tr>
    <tr style="height: 57.6111px;">
    <td style="width: 100.008%; padding: 15px;" colspan="2">
    <h3><strong><span style="font-size: 14.72px;">(B)&nbsp;How this technology / sub-system will be used as part of system and briefly describe the system &amp; constituents</span></strong></h3>
    </td>
    </tr>
    </tbody>
    </table>
    <h3><strong>2. Functionality Expected from the Output of the Project</strong></h3>
    <p>&nbsp;</p>
    <h3><strong>3. Flow Chart (If solution is process / Software based Solution) / Block Diagram / Logical Diagram / 3-Dimensional Visualization (if any) &ndash; Link it with Functionality, role, and place in overall system depicting various software / hardware interfaces.</strong></h3>
    <h3>&nbsp;</h3>
    <h3><strong>4. Detailed Technical Parameters</strong></h3>
    <h3 style="text-align: center;"><strong>&nbsp;(Table-2)</strong></h3>
    <table style="border-collapse: collapse; width: 100%; border-width: 2px; border-spacing: 10px; height: 1105.78px; margin-left: auto; margin-right: auto;" border="1" data-path-to-node="12">
    <thead>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 99.9933%;" colspan="3">&nbsp;</td>
    </tr>
    </thead>
    <tbody>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,1,0,0"><strong data-path-to-node="12,1,0,0" data-index-in-node="0">1.</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,1,1,0"><strong data-path-to-node="12,1,1,0" data-index-in-node="0">Functional Parameters</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;"><strong>Value</strong></td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,2,0,0">(i)</span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,2,1,0">............................</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,3,0,0">(ii)</span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,3,1,0">............................</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,5,0,0"><strong data-path-to-node="12,5,0,0" data-index-in-node="0">2.</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,5,1,0"><strong data-path-to-node="12,5,1,0" data-index-in-node="0">Important Technical Parameters</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,6,1,0">i. Overall System / Sub system / Module</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,7,1,0">ii. Critical Technologies and their parameters</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,8,1,0"><strong data-path-to-node="12,8,1,0" data-index-in-node="0">Parameters</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;"><span data-path-to-node="12,8,2,0"><strong data-path-to-node="12,8,2,0" data-index-in-node="0">Value</strong></span></td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,9,0,0">(i)</span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,9,1,0">............................................................</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,10,0,0">(ii)</span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,10,1,0">............................................................</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,12,0,0"><strong data-path-to-node="12,12,0,0" data-index-in-node="0">3</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,12,1,0"><strong data-path-to-node="12,12,1,0" data-index-in-node="0">Interfaces with other sub-systems ( if part of a bigger system / used as a Module / Subsystem)</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,13,1,0">i. Hardware</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,14,1,0">ii. Software</span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,15,0,0"><strong data-path-to-node="12,15,0,0" data-index-in-node="0">4.</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><strong><span data-path-to-node="12,15,1,0">Physical Parameters (Size, weight, Power, ergonomics etc.)</span></strong></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,8,1,0"><strong data-path-to-node="12,8,1,0" data-index-in-node="0">Parameters</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;"><span data-path-to-node="12,8,2,0"><strong data-path-to-node="12,8,2,0" data-index-in-node="0">Value</strong></span></td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><strong><span data-path-to-node="12,15,0,0"><span data-path-to-node="12,15,1,0">&nbsp; &nbsp; &nbsp;(i)</span><br></span></strong></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">&nbsp;..........................................<br></strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><strong><span data-path-to-node="12,15,0,0"><span data-path-to-node="12,15,1,0">&nbsp; &nbsp; (ii)</span><br></span></strong></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">..........................................<br></strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 106.222px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,15,0,0"><strong data-path-to-node="12,15,0,0" data-index-in-node="0">5.</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;">
    <p><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">List of applicable standards<br></strong></span></p>
    <p><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">(only for functionality and Non-Environmental performance)</strong></span></p>
    </td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 129.333px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><span data-path-to-node="12,15,0,0"><strong data-path-to-node="12,15,0,0" data-index-in-node="0">6.</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;">
    <p><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0"><strong>&nbsp;</strong></strong><strong>Environmental Specification </strong></span></p>
    <ol style="list-style-type: upper-roman;">
    <li><span data-path-to-node="12,15,1,0">Functional Testing</span></li>
    <li><span data-path-to-node="12,15,1,0">ESS<strong data-path-to-node="12,15,1,0" data-index-in-node="0"><br></strong></span></li>
    </ol>
    </td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;">&nbsp;</td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,8,1,0"><strong data-path-to-node="12,8,1,0" data-index-in-node="0">Parameters</strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;"><span data-path-to-node="12,8,2,0"><strong data-path-to-node="12,8,2,0" data-index-in-node="0">Value</strong></span></td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><strong><span data-path-to-node="12,15,0,0"><span data-path-to-node="12,15,1,0">&nbsp; &nbsp; &nbsp;(i)</span><br></span></strong></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">&nbsp;..........................................<br></strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    <tr style="height: 39.5556px;">
    <td style="border-width: 2px; padding: 10px; width: 4.65226%;"><strong><span data-path-to-node="12,15,0,0"><span data-path-to-node="12,15,1,0">&nbsp; &nbsp; (ii)</span><br></span></strong></td>
    <td style="border-width: 2px; padding: 10px; width: 87.8491%;"><span data-path-to-node="12,15,1,0"><strong data-path-to-node="12,15,1,0" data-index-in-node="0">..........................................<br></strong></span></td>
    <td style="border-width: 2px; padding: 10px; width: 7.49194%;">&nbsp;</td>
    </tr>
    </tbody>
    </table>
    <h3>&nbsp;</h3>
    <h4><strong>5. Important Performance / Specific features </strong>(up to 2 parameters) expected from each critical technologies (To be referred as Figure of Merit &ndash; FoM)</h4>
    <p style="padding-left: 40px;">(Bring out Quantitative value of performance &amp; features which can be tested in simulated / operational condition)<br>#This may be utilised in evaluation of important Milestones for decision making including termination if any.</p>
    <p>&nbsp;</p>
    <h4><strong>6. Details on expectations of Indigenous content:</strong></h4>
    <p style="padding-left: 40px;">i. To bring out any restriction on use of imported COTS components / Modules / Subsystems, Software components / SOFT IP cores in whole solution or part (bring out clarity on which part has restriction if any).<br>ii. Bring out conditions for accepting indigenous COTS equivalent component.<br>iii. What customization can be done on indigenously available COTS equivalent component. Restrictions of all types may be articulated appropriately in the BLOCK diagram given as above para &lsquo;3&rsquo;.<br>iv. Define minimum indigenous content for the solution required under the projec</p>
    <p>&nbsp;</p>
    <h4><strong>7. Testing / Acceptance Approach:</strong></h4>
    <ol style="list-style-type: upper-roman;">
    <li><strong>Majority / Acceptance based on ATP Document</strong>. Preparation of ATP document will be carried out based on parameters listed in Table -2 and will be finalized during PDR.</li>
    <li>A Formally constituted committee will carryout comprehensive testing using ATP document and recommend way ahead. Besides other mandate, following will be carried out by this committee:</li>
    <li>Recording of functionality &amp; performance measurement parameters as per ATP in the Lab.</li>
    <li>Demonstration of functionality/ performance of developed solution in suitable environment to be identified by ATP committee/ finalized during PDR.</li>
    <li>Valuation of FoM / other parameters.</li>
    <li>Analysis of Design / solution with respect to Indigenous content.</li>
    <li>Analysis for closeness of the achieved FoM / other parameters values to the targeted values and identification of deviation.</li>
    <li>Recommendation for way ahead based on demonstration result and achieved value FoM/ other Parameters.</li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>8. EXPECTED DEVELOPMENT SCHEDULE</strong></p>
    <p style="padding-left: 40px;">a. MILESTONES<br>b. DELIVERABLES<br>c. DOCUMENTATIONS (STAGE WISE AND FINAL)</p>
    <blockquote>
    <p>#<em><strong>Milestones that can be clearly demonstrated to facilitate project</strong></em> monitoring &amp; mentoring group (PMMG) and identification of critical activities. Milestone may be followed as per table below, list of deliverables at the end of each milestones along with project monitoring plan including PERT Chart needs to be submitted by the DA during response to Detailed Project Proposal (DPP) during the execution of the project.</p>
    </blockquote>
    <h3>&nbsp;</h3>
    <table style="border-collapse: collapse; width: 100%; border-width: 2px; height: 1872.5px; margin-left: auto; margin-right: auto;" border="1">
    <thead>
    <tr style="height: 76.5px;">
    <th style="border-width: 2px; width: 99.9866%; padding: 10px;" colspan="5">
    <h3><strong>Table-3: Phases of Implementation</strong></h3>
    </th>
    </tr>
    <tr style="height: 155.111px;">
    <th style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;">
    <p><strong>MS</strong></p>
    <p><strong>(Mile</strong></p>
    <p><strong>st</strong><strong>one)</strong></p>
    </th>
    <th style="border-width: 2px; width: 13.9038%; padding: 10px;"><strong>Time</strong></th>
    <th style="border-width: 2px; width: 43.525%; padding: 10px;"><strong>Major Activity Details</strong></th>
    <th style="border-width: 2px; width: 22.367%; padding: 10px;"><strong>Documents (Stage-wise)</strong></th>
    <th style="border-width: 2px; width: 10.579%; padding: 10px;"><strong>% of Project Cost</strong></th>
    </tr>
    </thead>
    <tbody>
    <tr style="height: 50px;">
    <td style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;" rowspan="7">1</td>
    <td style="border-width: 2px; width: 13.9038%; padding: 10px;" rowspan="7">
    <p>T0 + X1 months</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    </td>
    <td style="border-width: 2px; width: 43.525%; text-align: center; padding: 10px;"><span style="text-decoration: underline;"><strong><span style="font-size: 21px;">PRELIMINARY DESIGN REVIEW</span></strong></span></td>
    <td style="border-width: 2px; width: 22.367%; padding: 10px;" rowspan="7">Preliminary Design Report (PDR)</td>
    <td style="border-width: 2px; width: 10.579%; padding: 10px;" rowspan="7">~15%</td>
    </tr>
    <tr style="height: 44.1806px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Understanding of requirements</td>
    </tr>
    <tr style="height: 44.1806px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Establishment of design parameters</td>
    </tr>
    <tr style="height: 44.1806px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Identification of critical technology</td>
    </tr>
    <tr style="height: 44.1806px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Concept generation and evaluation</td>
    </tr>
    <tr style="height: 44.1806px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Preliminary design and analysis</td>
    </tr>
    <tr style="height: 44.2083px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Release of approved PDR document</td>
    </tr>
    <tr style="height: 74.2222px;">
    <td style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;" rowspan="6">2</td>
    <td style="border-width: 2px; width: 13.9038%; padding: 10px;" rowspan="6">
    <p>T0 + X2 months</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    </td>
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p style="text-align: center;"><span style="text-decoration: underline;"><span style="font-size: 18px;"><strong>DETAIL DESIGN REVIEW (DDR)</strong></span></span></p>
    </td>
    <td style="border-width: 2px; width: 22.367%; padding: 10px;" rowspan="6">Detail Design Report (DDR)Material Test Reports</td>
    <td style="border-width: 2px; width: 10.579%; padding: 10px;" rowspan="6">~15%</td>
    </tr>
    <tr style="text-align: center; height: 40.4444px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Procurement and testing of raw material</td>
    </tr>
    <tr style="text-align: center; height: 40.4444px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Detailed design of systems/sub-systems</td>
    </tr>
    <tr style="text-align: center; height: 40.4444px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Finalization of specs</td>
    </tr>
    <tr style="text-align: center; height: 40.4444px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Firming up of design drawings, documents and process plan</td>
    </tr>
    <tr style="height: 72.4444px; text-align: center;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p>Release of approved Detail Design Report (DDR) document</p>
    </td>
    </tr>
    <tr style="height: 44.375px;">
    <td style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;" rowspan="9">3</td>
    <td style="border-width: 2px; width: 13.9038%; padding: 10px;" rowspan="9">
    <p>&nbsp;</p>
    <p>T0 + X3 months</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    </td>
    <td style="border-width: 2px; width: 43.525%; text-align: center; padding: 10px;"><span style="text-decoration: underline;"><span style="font-size: 18px;"><strong>FUNCTIONAL PROTOTYPE DEVELOPMENT &amp; TESTING</strong></span></span></td>
    <td style="border-width: 2px; width: 22.367%; padding: 10px;" rowspan="9">Functional Test ReportsManufacturing Documents</td>
    <td style="border-width: 2px; width: 10.579%; padding: 10px;" rowspan="9">~20%</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Manufacture of prototype</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Establishment of test facility &amp; testing of prototype</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Functional testing</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Approved development report</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Approved test reports</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Finalization of Qualification/Acceptance Test Plan document</td>
    </tr>
    <tr style="height: 42.5px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Prototype delivery (Functional testing and ESS testing)</td>
    </tr>
    <tr style="height: 42.5694px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">Final Design &amp; Development Review (FDDR)</td>
    </tr>
    <tr style="height: 15px;">
    <td style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;" rowspan="7">4</td>
    <td style="border-width: 2px; width: 13.9038%; padding: 10px;" rowspan="7">
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>T0 + X4 months</p>
    <p>&nbsp;</p>
    </td>
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p style="text-align: center;" data-start="393" data-end="441"><span style="text-decoration: underline; font-size: 20px;"><strong data-start="393" data-end="441">QUALIFICATIONS TRIALS ON THE BASIS&nbsp;OF MoQs</strong></span></p>
    </td>
    <td style="border-width: 2px; width: 22.367%; padding: 10px;" rowspan="7">
    <ul>
    <li>QTP / QAP Plans</li>
    <li>Manufacturing design reports</li>
    <li>QA Acceptance / certified reports</li>
    <li>Clearance for manufacturing of final deliverables</li>
    <li>HATs and SATs and Single Stage Composite Trials</li>
    </ul>
    </td>
    <td style="border-width: 2px; width: 10.579%; padding: 10px;" rowspan="7">~30%</td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p data-start="443" data-end="504">CDR &amp; Clearance For Manufacturing of Engineering Proto Unit</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p data-start="506" data-end="552">QT Qualification by involvement of QT agency</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p data-start="554" data-end="596">QT Acceptance Testing Reports (approved)</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p data-start="598" data-end="690">Field trials Readiness &amp; evaluation (HATs and SATs) &ndash; SSCT (Single Stage Composite Trials)</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p data-start="692" data-end="775">Final production clearance for Delivery of Engineering Units post approval by QA.</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; text-align: justify; padding: 10px;">
    <p>Delivery of final deliverables</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="text-align: center; border-width: 2px; width: 9.61177%; padding: 10px;" rowspan="5">5</td>
    <td style="border-width: 2px; width: 13.9038%; padding: 10px;" rowspan="5">
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>T0 + X5 months</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    </td>
    <td style="border-width: 2px; width: 43.525%; padding: 10px;">
    <p style="text-align: center;" data-start="162" data-end="185"><span style="text-decoration: underline;"><span style="font-size: 20px;"><strong data-start="162" data-end="185">DOCUMENTATION &amp; TOT</strong></span></span></p>
    </td>
    <td style="border-width: 2px; width: 22.367%; padding: 10px;" rowspan="5">
    <ol>
    <li data-start="397" data-end="434">
    <p data-start="400" data-end="434">Project success / outcome report</p>
    </li>
    <li data-start="435" data-end="453">
    <p data-start="438" data-end="453">All Documents</p>
    </li>
    </ol>
    </td>
    <td style="border-width: 2px; width: 10.579%; padding: 10px;" rowspan="5">~20%</td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; padding: 10px;">
    <p data-start="187" data-end="253">Complete project documentations (Stage wise and final documents)</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; padding: 10px;">
    <p data-start="255" data-end="289">Project Success / Outcome Report</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; padding: 10px;">
    <p data-start="291" data-end="309">Execution of ToT</p>
    </td>
    </tr>
    <tr style="height: 15px;">
    <td style="border-width: 2px; width: 43.525%; padding: 10px;">
    <p data-start="162" data-end="185">Technology Asset Management Agreement<br data-start="348" data-end="351">(Tangible Asset / Sharing IP)<strong data-start="162" data-end="185"><br></strong></p>
    </td>
    </tr>
    <tr style="height: 107.111px;">
    <td style="text-align: center; border-width: 2px; width: 99.9866%; padding: 10px;" colspan="5">
    <p style="text-align: left;" data-start="470" data-end="480"><strong data-start="470" data-end="480">Note :</strong></p>
    <p style="text-align: left;" data-start="482" data-end="538">&bull; Listing of final deliverables at the end of projects</p>
    <p style="text-align: left;" data-start="540" data-end="655">&bull; The Milestone wise time required and Project completion % age may be finalized at CNC in consultation with PMMG</p>
    <p style="text-align: left;" data-start="657" data-end="841">&bull; Tentative project duration is <strong data-start="689" data-end="702">24 months</strong> (Till Prototype development and Functional &amp; ESS testing) further extended time to finish Qualification, Testing/Certification and Trials.</p>
    </td>
    </tr>
    </tbody>
    </table>
          <p>&nbsp;</p>`}
  return '';
}

export function getTprFromTemplate(proposalName: string) {
  return `<h2>&nbsp;</h2>
<table style="width: 100.028%; height: 2064.56px; border-collapse: collapse; background-color: #ecf0f1; border-color: #000000; border-width: 2px; border-spacing: 10px;" border="1">
<tbody>
<tr style="height: 53.4444px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="2">1</td>
<td style="width: 95.4958%; border-color: #000000; border-width: 2px; padding: 10px;" colspan="2" rowspan="2">
<p>Title of the Project: ${proposalName}<br><br></p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 53.4444px;"></tr>
<tr style="height: 21.5556px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="2">3</td>
<td style="width: 95.4958%; border-color: #000000; border-width: 2px; padding: 10px;" colspan="2" rowspan="2">
<p>User Lab / Armed Forces<br><br></p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 106.889px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">5</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Technology Category</p>
<p>&nbsp; &nbsp; &nbsp;Indigenization / Up-gradation / Critical / Deep-tech</p>
</td>
</tr>
<tr style="height: 40.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">6</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Desired Outcome<br>(Technology / Component / Subsystem / System / Product / Process etc.)</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 34.9306px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="4">7</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2" rowspan="4">
<p><strong>Problem / Requirements Definition</strong></p>
<ol style="list-style-type: upper-roman;">
<li>Describe the problem area with expected impact</li>
<li>Flow Chart / Block Diagram / Logical Diagram</li>
<li>Critical technologies involved<br><br></li>
</ol>
</td>
</tr>
<tr style="height: 65.1667px;"></tr>
<tr style="height: 65.1667px;"></tr>
<tr style="height: 34.9306px;"></tr>
<tr style="height: 21.5556px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="6">8</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2" rowspan="6">
<p><strong>Details of Technologies / Subsystems</strong></p>
<ol style="list-style-type: upper-roman;">
<li>Usage of technology / subsystem in overall system</li>
<li>Functionality / Performance / Key features</li>
<li>Critical technologies to be indigenized</li>
<li>Critical import components / procurement issues</li>
<li>Main parameters / performance range</li>
</ol>
</td>
</tr>
<tr style="height: 40.1806px;"></tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 40.1806px;"></tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 21.5556px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="4">9</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2" rowspan="4">
<p><strong>Nature of Deliverables</strong></p>
<ol style="list-style-type: upper-roman;">
<li>Nature of solution (Prototype / HW / SW / Process / Digital Twin etc.</li>
<li>Likely quantity required (2&ndash;5 years)</li>
<li>Additional quantity for trials / integration</li>
</ol>
</td>
</tr>
<tr style="height: 60.8889px;"></tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 21.5556px;"></tr>
<tr style="height: 31.3889px;">
<td style="border-color: #000000; width: 4.46976%; border-width: 2px; padding: 10px;" rowspan="4">10</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2" rowspan="4">
<p><strong>Development Rough Cost Estimates</strong></p>
<ol style="list-style-type: upper-roman;">
<li>Overall Cost</li>
<li>Cost of individual technologies</li>
<li>Documentary support for costing</li>
</ol>
</td>
</tr>
<tr style="height: 31.3889px;"></tr>
<tr style="height: 31.3889px;"></tr>
<tr style="height: 31.3889px;"></tr>
<tr style="height: 53.5556px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">11</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Likely Project Timeline</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">12</td>
<td style="width: 18.9059%; border-color: #000000; border-width: 2px; padding: 10px;">
<p>Background technologies from DRDO</p>
<p>&nbsp;</p>
</td>
<td style="width: 76.59%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">13</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Potential industries</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">14</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Potential academic / R&amp;D partners</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">15</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>RFI inputs / Evaluation criteria</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">16</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Multiple industry requirement (risk mitigation)</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">17</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Spin-off / Dual-use technology</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">18</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>No. of industries to be selected (01 / 02 / 03)</p>
<p>&nbsp;</p>
</td>
</tr>
<tr style="height: 125.556px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">19</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Type of industry to be selected for this Projects i.e. Project will be restricted to award only</p>
<ol>
<li>START-UP</li>
<li>&nbsp;MSME</li>
<li>LARGE</li>
</ol>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">16</td>
<td style="border-color: #000000; width: 95.4958%; border-width: 2px; padding: 10px;" colspan="2">
<p>Any other information:</p>
</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
<td style="width: 18.9059%; border-color: #000000; border-width: 2px; padding: 10px;">
<p><strong>Prepared By</strong></p>
<p>&nbsp;(User / Project Manager of Lab)</p>
</td>
<td style="width: 76.59%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
<td style="width: 18.9059%; border-color: #000000; border-width: 2px; padding: 10px;">
<p><strong>Reviewed By&nbsp;</strong></p>
<p>(Project Director, Lab)</p>
</td>
<td style="width: 76.59%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
</tr>
<tr style="height: 88.2222px;">
<td style="width: 4.46976%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
<td style="width: 18.9059%; border-color: #000000; border-width: 2px; padding: 10px;">
<p><strong>Approved By </strong></p>
<p>(Lab Director / Associate Director)</p>
</td>
<td style="width: 76.59%; border-color: #000000; border-width: 2px; padding: 10px;">&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
    `
}


export function getFeasibilityStudyTemplate(proposalName: string, stepDetails: any): string {
  if ([6, 14, 12,16].includes(stepDetails?.step_mapping?.scheme?.id)) {
    return `<h2 style="padding-left: 40px; text-align: center;"><strong>${proposalName}</strong></h2>
    <h3><span style="text-decoration: underline;"><span style="font-size: 16.72px;">Introduction</span></span></h3>
    <p style="padding-left: 40px;">1.&emsp;Background.<br>2.&emsp;Requirement.</p>
    <h3><span style="text-decoration: underline; font-size: 16.72px;">Aim and Scope</span></h3>
    <p style="padding-left: 40px;">3.&emsp;Aim.<br>4.&emsp;Scope.</p>
    <h3><span style="text-decoration: underline;"><span style="font-size: 16.72px;">Study Methodology</span></span></h3>
    <p style="padding-left: 40px;">5.&emsp;Preliminary Study.<br>6.&emsp;System Composition.<br>7.&emsp;Feasibility Study.<br>8.&emsp;Present Status of the case.<br>9.&emsp;Project Facilitation Team.</p>
    <h3><span style="text-decoration: underline;"><span style="font-size: 16.72px;">Response to Questionnaire &ndash; Firm 1</span></span></h3>
    <p style="padding-left: 40px;">10.&emsp;Background<br>&emsp;&emsp;(a)&emsp;System Description.<br>&emsp;&emsp;(b)&emsp;Indigenous Content.<br>&emsp;&emsp;(c)&emsp;Anticipated Timelines for Development.<br>&emsp;&emsp;(d)&emsp;Design and Development Costs.<br>&emsp;&emsp;(e)&emsp;Budgetary Cost.</p>
    <h3><span style="text-decoration: underline;"><span style="font-size: 16.72px;">Response to Questionnaire &ndash; Firm 2</span></span></h3>
    <p style="padding-left: 40px;">11.&emsp;Background<br>&emsp;&emsp;(a)&emsp;System Description.<br>&emsp;&emsp;(b)&emsp;Indigenous Content.<br>&emsp;&emsp;(c)&emsp;Anticipated Timelines for Development.<br>&emsp;&emsp;(d)&emsp;Design and Development Costs.<br>&emsp;&emsp;(e)&emsp;Budgetary Cost.</p>
    <p style="padding-left: 40px;">12.&emsp;Comparative Response of Vendors.</p>
    <h3><span style="text-decoration: underline; font-size: 16.72px;">Recommendations</span></h3>
    <p style="padding-left: 40px;">13.&emsp;Assessment of Enabling Technology.</p>
    <p style="padding-left: 40px;">14.&emsp;Feasibility of Progressing Under Make.<br>15.&emsp;Timeline for Prototype Development.<br>16.&emsp;Conduct of UETs.<br>17.&emsp;Estimated Production Cost.<br>18.&emsp;Categorisation.<br>19.&emsp;Dependency on foreign nations for critical enabling technology / component.<br>20.&emsp;Technologies / Sub-systems / LRUs / Software indigenously developed.<br>21.&emsp;Quantity.<br>22.&emsp;Foreclosure Criteria.<br>23.&emsp;Technical Eligibility Criteria.</p>
    <p style="padding-left: 40px;">&nbsp;</p>`
  }
  return '';
};

export function getSotrRfpComplienceTemplate(projectName: string, venderList: any[]): string {

  const venderHeader = venderList.map((vender: any) => `<td class="xl115" style="border-width: 2px; border-left-style: none; border-left-color: initial; padding: 10px;" colspan="2">M/s ${vender}</td>`).join('')
  const venderMarge = venderList.map((vender: any) => `<td class="xl80" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; width: 95pt; padding: 10px;" width="126">Compliance Yes/No</td>
                                                    <td class="xl68" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; width: 77pt; padding: 10px;" width="103">TEC Observations</td>`).join('')

  const coloumn = venderList.map((vender: any) => `<td class="xl80" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; width: 95pt; padding: 10px;" width="126"></td>
                                                    <td class="xl68" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; width: 77pt; padding: 10px;" width="103"></td>`).join('')
  const rows = venderList.map((vender: any) => `<tr style="mso-height-source: userset; height: 17.25pt;">
                    <td style="width: 12.25pt; border-width: 2px; padding: 10px;">&nbsp;</td>
                    <td class="xl70" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; width: 179pt; padding: 10px;" width="238">&nbsp;</td>
                    ${coloumn}
                    <td class="xl66" style="border-width: 2px; border-top-style: none; border-top-color: initial; border-left-style: none; border-left-color: initial; padding: 10px;">&nbsp;</td>
                    </tr>`).join('')
  return ` <table style="border-collapse: collapse; width: 1413px; border-width: 2px; border-spacing: 0px;" border="1" width="1413" cellspacing="0" cellpadding="0"><colgroup><col style="width: 47px;"><col style="width: 189px;" width="238"><col style="width: 110px;" width="94"><col style="width: 118px;" width="102"><col style="width: 134px;" width="126"><col style="width: 118px;" width="103"><col style="width: 120.972px;" span="2" width="107"><col style="width: 117px;" width="101"><col style="width: 124px;" width="112"><col style="width: 212px;" width="257"></colgroup>
<tbody>
<tr style="mso-height-source: userset; height: 31.5pt;">
<td style="border-width: 2px; padding: 10px;" colspan="${venderList.length * 2 + 3}">
<h2 style="text-align: center;">${projectName}</h2>
</td>
</tr>
<tr style="mso-height-source: userset; height: 15.75pt;">
<td style="border-width: 2px; border-bottom-style: solid; border-bottom-color: black; border-top-style: none; border-top-color: initial; width: 12.25pt; padding: 10px;" rowspan="2">Ser</td>
<td class="xl68" style="border-width: 2px; border-top-style: none; border-top-color: initial; width: 179pt; padding: 10px;" rowspan="2" width="238">Para of RFP<span style="mso-spacerun: yes;">&nbsp;</span></td>
  ${venderHeader}
<td class="xl107" style="border-width: 2px; border-bottom-style: solid; border-bottom-color: black; border-top-style: none; border-top-color: initial; padding: 10px;" rowspan="2">Remarks</td>
</tr>
<tr style="mso-height-source: userset; height: 39.75pt;">
  ${venderMarge}
</tr>
<tr style="mso-height-source: userset; height: 15.0pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl109" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 15pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" height="20">PART I - General Information</td>
</tr>
  ${rows}
<tr style="height: 15.6pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl112" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 15.6pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" height="21">PART II-Essential Details of the item</td>
</tr>
${rows}
<tr style="height: 15.6pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl112" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 15.6pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" height="21">PART III- Standard<span style="mso-spacerun: yes;">&nbsp;</span></td>
</tr>
${rows}
<tr style="height: 15.6pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl112" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 15.6pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" height="21">PART IV- Special Conditions of RFP</td>
</tr>
${rows}
<tr style="mso-height-source: userset; height: 20.25pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl123" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 20.25pt; width: 867pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" width="1156" height="26">PART V- Evaluation Criteria and Format for Price Bids</td>
</tr>
${rows}
<tr style="mso-height-source: userset; height: 18.75pt;">
<td style="border-width: 2px; border-right-style: solid; border-right-color: black; padding: 10px;">&nbsp;</td>
<td class="xl118" style="border-width: 2px; border-right-style: solid; border-right-color: black; height: 18.75pt; width: 867pt; padding: 10px;" colspan="${venderList.length * 2 + 2}" width="1156" height="25">PART VI- Standard Conditon for Quality Assurance (SCQA)</td>
</tr>
${rows}
</tbody>
</table>
<p>&nbsp;</p>`;
}

export function getTenderOpeningSheetTemplate(tName: string, stepDetails: any): string {
  let natureOfBid = '';

  if (stepDetails?.code === 'R-TO&RFP') {
    natureOfBid = 'Technical Bid';
  }
  else if (stepDetails?.code === 'Q-CST') {
    natureOfBid = 'Commercial Bid';
  }
  return `<h2 style="text-align: center;"><strong>${tName}</strong></h2>
<div style="text-align: center; line-height: 1.4;"><span style="font-size: 16pt;"><strong>Item / Equipment:</strong></span></div>
<div style="text-align: center; line-height: 1.4;"><span style="font-size: 16pt;"><strong>DOI Reference:</strong></span></div>
<div style="text-align: center; line-height: 1.4;"><span style="font-size: 16pt;"><strong>Nature of Bid: ${natureOfBid}</strong></span></div>
<div style="text-align: center; line-height: 1.4;"><span style="font-size: 16pt;"><strong>Date / Time of Opening:</strong></span></div>
<p>&nbsp;</p>
<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
<thead>
<tr style="background-color: #f8f9fa;">
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 8%;">Sl. No.</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 15%;">Firm Name</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 15%;">Bid Reference &amp; Date</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 15%;">Firm Representative</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 12%;">Contact Number</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 20%;">Documents Submitted</th>
<th style="border: 1px solid #ddd; padding: 8px; text-align: center; width: 15%;">Remarks</th>
</tr>
</thead>
<tbody>
<tr>
<td style="border: 1px solid #ddd; padding: 8px; text-align: center;">1</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
</tr>
</tbody>
</table>`;
}

export function getCSTMatrixTemplate(): string {
  return `
  <div style="font-family: Arial, sans-serif; font-size: 12px;">

    <h4 style="text-align:center; margin-bottom:15px;">
      <strong>CST MATRIX TABLE</strong>
    </h4>

    <table style="width:100%; border-collapse:collapse; border:1px solid #000;">
      <thead>
        <tr>
          <th rowspan="2" style="border:1px solid #000; padding:6px; width:5%;">Sl No</th>
          <th rowspan="2" style="border:1px solid #000; padding:6px; width:20%;">Description</th>
          <th colspan="3" style="border:1px solid #000; padding:6px;">Firm A<br/>M/s XXX</th>
          <th colspan="3" style="border:1px solid #000; padding:6px;">Firm B<br/>M/s XXX</th>
          <th colspan="3" style="border:1px solid #000; padding:6px;">Firm C<br/>M/s XXX</th>
          <th colspan="3" style="border:1px solid #000; padding:6px;">Firm D<br/>M/s XXX</th>
        </tr>
        <tr>
          ${Array(4).fill(`
            <th style="border:1px solid #000; padding:6px;">Unit Price (Rs)</th>
            <th style="border:1px solid #000; padding:6px;">Qty</th>
            <th style="border:1px solid #000; padding:6px;">Total (Rs)</th>
          `).join('')}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td style="border:1px solid #000; padding:6px;">1</td>
          <td style="border:1px solid #000; padding:6px;">
            Firm’s Quotation No & Date
          </td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">2</td>
          <td style="border:1px solid #000; padding:6px;">
            Item / Equipment Description
          </td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">3</td>
          <td style="border:1px solid #000; padding:6px;">
            Development cost of one Pilot sample including cost of type testing and trials as per SOTRs
          </td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">4</td>
          <td style="border:1px solid #000; padding:6px;">
            Item as per Statement of Technical Requirements (SOTRs)
          </td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">5</td>
          <td style="border:1px solid #000; padding:6px;">Accessories as per SOTRs</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">6</td>
          <td style="border:1px solid #000; padding:6px;">Installation / Commissioning</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">7</td>
          <td style="border:1px solid #000; padding:6px;">Training</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">8</td>
          <td style="border:1px solid #000; padding:6px;">Technical Literature</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">9</td>
          <td style="border:1px solid #000; padding:6px;">Spares (as per SOTRs)</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">10</td>
          <td style="border:1px solid #000; padding:6px;">Tools</td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">11</td>
          <td style="border:1px solid #000; padding:6px;">
            Taxes<br/>
            (i) GST / IGST<br/>
            (ii) Basic Custom Duty<br/>
            (iii) Any other taxes
          </td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

        <tr>
          <td style="border:1px solid #000; padding:6px;">12</td>
          <td style="border:1px solid #000; padding:6px;"><strong>Total</strong></td>
          ${Array(12).fill(`<td style="border:1px solid #000; padding:6px;"></td>`).join('')}
        </tr>

      </tbody>
    </table>
  </div>
  `;
}

export function getEoiTemplate(): string {
  return `
<h2 style="text-align: center; line-height: 1.4;"><strong><span style="text-decoration: underline;">INTEGRATED HEADQUARTERS OF MINISTRY OF DEFENCE (NAVY)</span></strong></h2>
<h3 style="text-align: center; line-height: 1.4;"><strong>DIRECTORATE NAME</strong></h3>
<p>&nbsp;</p>
<h3 style="text-align: center; line-height: 1.4;"><strong><span style="text-decoration: underline;">INVITATION FOR EXPRESSION OF INTEREST (EOI)</span></strong>&nbsp;</h3>
<h4 style="text-align: center; line-height: 1.4;"><strong>PROJECT NAME</strong></h4>
<p>&nbsp;</p>
<table style="width: 100%; border-collapse: collapse;" border="0">
<tbody>
<tr>
<td style="width: 20%; padding: 5px;"><strong><span style="text-decoration: underline;">Reference</span></strong></td>
<td style="width: 5%; padding: 5px;">:</td>
<td style="width: 75%; padding: 5px;"><strong>Defence Acquisition Procedure 2020 (DAP 2020)</strong></td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong><span style="text-decoration: underline;">Appendices:</span></strong></p>
<table style="width: 100%; border-collapse: collapse;" border="0">
<tbody>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'A'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Indigenous Content Aspects</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'B'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">IPR of Government</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'C'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Financial and Commercial Assessment Criteria</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'D'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Financial Assessment Criteria for Start-ups</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'E'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Commercial Assessment Criteria for Start-ups</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'F'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Technical Capability Assessment Criteria</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'G'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Information Performa</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'H'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Certificate</td>
</tr>
<tr>
<td style="width: 25%; padding: 4px;"><strong>Appendix 'J'</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 70%; padding: 4px;">Trial Methodology</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h4><strong><span style="text-decoration: underline;">Introduction</span></strong></h4>
<p>&nbsp;</p>
<p>&nbsp;</p>
<h4><strong><span style="text-decoration: underline;">Objective</span></strong></h4>
<p>&nbsp;</p>
<p>&nbsp;</p>
<h4><strong><span style="text-decoration: underline;">Layout</span></strong></h4>
<p>&nbsp;</p>
<p><strong>1.</strong>&nbsp;&nbsp;&nbsp;The EoI has been covered under the following parts:-</p>
<table style="width: 80%; border-collapse: collapse; margin-left: 40px;" border="0">
<tbody>
<tr>
<td style="width: 10%; padding: 4px;">(a)</td>
<td style="width: 20%; padding: 4px;"><strong>Part I</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 65%; padding: 4px;">General Information</td>
</tr>
<tr>
<td style="width: 10%; padding: 4px;">(b)</td>
<td style="width: 20%; padding: 4px;"><strong>Part II</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 65%; padding: 4px;">Technical Requirements</td>
</tr>
<tr>
<td style="width: 10%; padding: 4px;">(c)</td>
<td style="width: 20%; padding: 4px;"><strong>Part III</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 65%; padding: 4px;">Critical Technology Areas</td>
</tr>
<tr>
<td style="width: 10%; padding: 4px;">(d)</td>
<td style="width: 20%; padding: 4px;"><strong>Part IV</strong></td>
<td style="width: 5%; padding: 4px;">:</td>
<td style="width: 65%; padding: 4px;">Eligibility Criteria</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`;
}

export function getSqrDefaultContent(): string {
  return `
<table style="width: 100%; border-collapse: collapse; border: 2px solid #000; font-family: Arial, sans-serif;">
  <thead>
    <tr style="background-color: #d3d3d3;">
      <th style="border: 2px solid #000; padding: 8px 12px; text-align: center; width: 10%;"></th>
      <th colspan="2" style="border: 2px solid #000; padding: 8px 12px; text-align: center;">TOPIC</th>
      <th style="border: 2px solid #000; padding: 8px 12px; text-align: center; width: 15%;">PAGE NO.</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">I</td>
      <td colspan="2" style="border: 2px solid #000; padding: 8px 12px; font-weight: bold;">Introduction</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">4</td>
    </tr>
    <tr>
      <td rowspan="4" style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold; vertical-align: middle;">II</td>
      <td colspan="2" style="border: 2px solid #000; padding: 8px 12px; font-weight: bold;">Essential Parameters A</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">5-14</td>
    </tr>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center;">Section A</td>
      <td style="border: 2px solid #000; padding: 8px 12px;">Operational Parameters</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">5-10</td>
    </tr>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center;">Section B</td>
      <td style="border: 2px solid #000; padding: 8px 12px;">Technical Parameters</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">11</td>
    </tr>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center;">Section C</td>
      <td style="border: 2px solid #000; padding: 8px 12px;">Maintainability and Ergonomic Parameters</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">12-14</td>
    </tr>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">III</td>
      <td colspan="2" style="border: 2px solid #000; padding: 8px 12px; font-weight: bold;">Essential Parameters B</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">14</td>
    </tr>
    <tr>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">IV</td>
      <td colspan="2" style="border: 2px solid #000; padding: 8px 12px; font-weight: bold;">Enhanced Performance Parameters</td>
      <td style="border: 2px solid #000; padding: 8px 12px; text-align: center; font-weight: bold;">14</td>
    </tr>
  </tbody>
</table>
`;
}


export function getQuestionnaireTemplate(): string {
  return `
<h3 style="text-align:center; line-height:1.4;">
<strong><span style="text-decoration: underline;">
QUESTIONNAIRE FOR INDIGENOUS DEVELOPMENT OF EFFECTORS FOR ANTI-TORPEDO COUNTERMEASURE SYSTEM
</span></strong>
</h3>

<p><strong>1. Name of the Company/Vendor/Firm.</strong><br>
Company profile, in brief, to be attached</p>

<p><strong>2. Type (Tick the Relevant Category)</strong></p>

<table style="width:100%; border-collapse:collapse;" border="1">
<tr>
<td style="width:60%; padding:6px;">(a) Original Equipment Manufacturer (OEM)</td>
<td style="width:20%; padding:6px;">Yes / No</td>
</tr>
<tr>
<td style="padding:6px;">(b) Authorised Vendor of Foreign Firm</td>
<td style="padding:6px;">Yes / No</td>
</tr>
<tr>
<td style="padding:6px;">(c) Other (give specific details)</td>
<td style="padding:6px;">Attach details if Yes</td>
</tr>
</table>

<p><strong>3. Contact Details.</strong></p>

<p><strong>4. Contact Details of Local Branch/Liaison Office in Delhi (if any).</strong></p>

<p><strong>5. Financial Details.</strong></p>

<p>(a) Category of Industry (Large / Medium / Small Scale).</p>
<p>(b) Annual Turnover (INR).</p>
<p>(c) Number of Employees in Firm.</p>
<p>(d) Details of Manufacturing Infrastructure.</p>

<p>(e) Earlier Contracts with Ministry of Defence / Government Agencies:</p>

<table style="width:100%; border-collapse:collapse;" border="1">
<tr>
<th style="padding:6px;">Contract No</th>
<th style="padding:6px;">Equipment</th>
<th style="padding:6px;">Quantity</th>
<th style="padding:6px;">Cost</th>
</tr>
<tr>
<td style="padding:10px;"></td>
<td></td>
<td></td>
<td></td>
</tr>
</table>

<p><strong>6.</strong> Please provide compliance to industry standards and details of ISO Certification.</p>

<p><strong>7.</strong> Details of Registration.</p>

<table style="width:100%; border-collapse:collapse;" border="1">
<tr>
<th style="padding:6px;">Agency</th>
<th style="padding:6px;">Registration No</th>
<th style="padding:6px;">Validity (Date)</th>
<th style="padding:6px;">Equipment</th>
</tr>
<tr>
<td style="padding:10px;"></td>
<td></td>
<td></td>
<td></td>
</tr>
</table>

<p><strong>8.</strong> Membership of FICCI / ASSOCHAM / CII or other Industrial Association and Registration number.</p>

<p><strong>9.</strong> Provide description of the vendor organisation in terms of R&D of electronic and acoustic systems including the financial capability and the technical expertise.</p>

<p><strong>10.</strong> Provide details regarding major successful projects/products/technologies developed/under development involving R&D in the field of electronic and countermeasure systems.</p>

<p><strong>11.</strong> Does the vendor have adequate infrastructure and capability for development, manufacture, testing, qualification and integration of the system? If yes, the details to be provided. If no, what is the source and what would be the timeframe for establishing the same?</p>

<p><strong>12.</strong> Provide details of similar item manufactured by the vendor and supplied in India abroad, if any.</p>

<p><strong>13.</strong> What are the critical technologies which the vendor has taken from their global partners which is envisaged to be used for the extent development, if any?</p>

<p><strong>14.</strong> Does the vendor have the capability to develop an Effector prototype and undertake production of the same?</p>

<p><strong>15.</strong> What are the components of the envisaged Effector? Provide brief technical details of components and working of the system.</p>

<p><strong>16.</strong> Is vendor aware of the power supply envisaged for the Effector?</p>

<p><strong>17.</strong> What is the plan of action of the vendor for replicating the capabilities of the imported Effectors available with the IN?</p>

<p><strong>18.</strong> Would the indigenously developed Effector be compatible with the launcher of IN submarines?</p>

<p><strong>19.</strong> What are technology gaps envisaged by the vendor in the indigenous development and production of Effectors?</p>

<p><strong>20.</strong> Any collaboration/joint venture/co-production/authorised dealer envisaged for indigenous development of the Effector. If yes, provide details.</p>

<p><strong>21.</strong> What is the approximate indigenous content the vendor will be able to achieve? Give a breakdown of the indigenous content and the imported technology/other items in terms of cost percentages.</p>

<p><strong>22.</strong> What are the major components/systems/sub-systems envisaged to be indigenously manufactured by the vendor? What will be the source of acquisition for the remaining components/systems/sub-systems?</p>

<p><strong>23.</strong> What are the proprietary technologies envisaged to be incorporated in the Effectors? Are the proprietary technologies indigenous or ex-import? If ex-import, will the Foreign vendor transfer the technology? Clarify the issues of Intellectual Property Rights (IPR) for the Effectors.</p>

<p><strong>24.</strong> What is the way-ahead planned for Transfer of Technology (ToT) to achieve self-reliance?</p>

<p><strong>25.</strong> What are the anticipated timelines (in months) for development of the prototype and production? Specify the timelines separately for each.</p>

<p><strong>26.</strong> What will be the likely production capacity per annum?</p>

<p><strong>27.</strong> Does the vendor have EMI/EMC test facilities? If no, source of testing to be indicated.</p>

<p><strong>28.</strong> What is the likely service life and shelf life of the Effector planned for indigenous development?</p>

<p><strong>29.</strong> Does the vendor have the ability to provide technical support for the Effector during its lifecycle?</p>

<p><strong>30.</strong> Does the vendor envisage any Maintenance Tools, Test Equipment, Test Jigs and fixtures that would be required for maintenance support for its life cycle? If yes, list out the tools, equipment, jigs and fixtures.</p>

<p><strong>31.</strong> How will the vendor ensure continuous supply of spares for the Effectors, especially for imported components, if any?</p>

<p><strong>32.</strong> Any additional details in respect of the proposed development carried out may be provided.</p>

`;
}


export function getSpbProposalTemplate(): string {
  return `
<h3 style="text-align:center;">
<strong>
STATEMENT OF CASE TO BE CONSIDERED BY SPB FOR CATEGORISATION <br>
AND ACCORD OF AoN FOR INDIGENOUS DESIGN, DEVELOPMENT AND MANUFACTURE <br>
(OF NAME OF PROPOSAL) UNDER BUY INDIAN-IDDM CATEGORY THROUGH MAKE II ROUTE
</strong>
</h3>

<br>

<table style="width:100%; border-collapse:collapse;" border="0">
<tr>
<td style="width:25%;"><strong>NAME OF PROPOSAL</strong></td>
<td style="width:5%;">-</td>
<td>Name of proposal</td>
</tr>

<tr>
<td><strong>SERVICE</strong></td>
<td>-</td>
<td>Indian Navy</td>
</tr>

<tr>
<td><strong>CATEGORISATION STATUS</strong></td>
<td>-</td>
<td>Buy Indian (IDDM) under Make II</td>
</tr>

<tr>
<td><strong>REFERENCE NO ALLOCATED</strong></td>
<td></td>
<td></td>
</tr>

<tr>
<td style="padding-left:20px;">(a) SPB</td>
<td>-</td>
<td></td>
</tr>
</table>

<br>

<h4 style="text-align:center;"><strong>BRIEF OF PROPOSAL</strong></h4>

<p><strong>1. Introduction.</strong></p>

<p><strong>2. Proposal</strong></p>

<p style="padding-left:20px;"><strong>(a) Mission Needs</strong></p>

<p style="padding-left:20px;"><strong>(b) How Mission Currently Undertaken.</strong></p>

<p style="padding-left:20px;"><strong>(c) Deficiency in Capability Observed which need Rectification.</strong></p>

<p style="padding-left:20px;"><strong>(d) Whether Changes in Doctrine / Tactics cannot overcome the void without a Material Solution.</strong></p>

<p style="padding-left:20px;"><strong>(e) Material Solution Proposed with Time Frame and Linkages to ICDP.</strong></p>

<p style="padding-left:40px;">(i) What is the capability being sought to be inducted?</p>

<p style="padding-left:40px;">(ii) What additional capability is being generated? How does this mesh with the long-term capability requirements?</p>

<p style="padding-left:40px;">(iii) In case of phased induction of equipment, what are the exact quantities sought during various plan periods / stages?</p>

<p style="padding-left:40px;">(iv) Whether technology is state of the art and ToT considered?</p>

<p style="padding-left:40px;">(v) In cases where ToT is being sought, which is the PA identified by DDP/Vendors for the same? What are the capabilities or absorption of ToT manufacture as per requirements? Does it meet the eligibility as spelt out by DDP?</p>

<p style="padding-left:40px;">(vi) Inputs from SHQ, if any, for selection of PA</p>

<p style="padding-left:20px;"><strong>(g) Whether Item is Scaled / Not Scaled. If Scaled, quote Authority</strong></p>

<br>

<h4><strong>(h) Maintenance Aspects.</strong></h4>

<p style="padding-left:40px;">(i) How is the engineering/maintenance support catered for the full life cycle of the equipment? Is a ToT proposed for providing maintenance infrastructure to an Indian firm? If so, are Indian entities identified based upon inputs from DDP?</p>

<p style="padding-left:40px;">(ii) How are D Level repairs planned to be carried out? OEM / Vendor or Indian entities or Services Maintenance Agency</p>

<p style="padding-left:40px;">(iii) Details of GSQR / JSQR.</p>

<p style="padding-left:40px;">(iv) In all cases essential capability and corresponding minimum verifiable functional characteristics in a tabulated form be provided</p>

<br>

<table style="width:70%; border-collapse:collapse;" border="1">
<tr>
<th>Ser</th>
<th>Specifications</th>
<th>Details</th>
</tr>

<tr>
<td>(aa)</td>
<td>Purpose</td>
<td></td>
</tr>

<tr>
<td>(ab)</td>
<td>Modes of Operation</td>
<td></td>
</tr>

<tr>
<td>(ac)</td>
<td>Physical Dimensions</td>
<td></td>
</tr>

<tr>
<td>(ad)</td>
<td>Functional Parameters</td>
<td></td>
</tr>

<tr>
<td>(ae)</td>
<td>End Use</td>
<td></td>
</tr>
</table>

<br>

<p><strong>(v)</strong> For all Repeat Order cases of equipment already inducted into service, are there any changes in SQR, modifications of minor nature or upgrades of assemblies/sub assemblies involved?</p>

<p>Would this need a commercial RFP with validation of modifications/ upgrades, or issuing of a fresh techno commercial RFP for a multi vendor basis?</p>

<p><strong>(vi)</strong> In all cases details of essential verifiable functional characteristics vis-à-vis technical parameter of the equipment available in the World market, in as much details as possible in a tabulated form be provided.</p>

<p><strong>(vii)</strong> In cases where earlier approved GSQRs have necessitated amendment and revalidation of AoN, detailed justification for each amendment be provided in a tabulated form.</p>

<p><strong>(j)</strong> Whether proposal is for replacement / upgrade / new induction making up WRM deficiency?</p>

<p><strong>(k)</strong> Trials schedule for induction to give full details of induction/delivery schedules.</p>

<p><strong>(l)</strong> Commonality and interoperability aspects with other services.</p>

`;
}


export function getProjectSanctionOrderTemplate(): string {
  return `
  <div style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.6;">

    <!-- HEADER -->
    <h4 style="text-align:center; text-decoration: underline; margin-bottom:20px;">
      Sample Format of Project Sanction Order
    </h4>

    <div style="display:flex; justify-content:space-between;">
      <div>
        <div>Tele: (012) 3456 7890 – (Telefax)</div>
        <div>Email: provide.official.email.here@gov.in</div>
      </div>
      <div style="text-align:right;">
        Provide complete correspondence address of<br/>
        PFT or Sponsor dte<br/>
        New Delhi – 110010
      </div>
    </div>

    <br/><br/>

    <div style="display:flex; justify-content:space-between;">
      <div>SHQ/Indicate case file reference here</div>
      <div>(date)</div>
    </div>

    <br/>

    <!-- ADDRESS -->
    <div>
      To,<br/><br/>
      <strong>Complete address of the DA</strong>
    </div>

    <br/><br/>

    <!-- TITLE -->
    <div style="text-align:center;">
      <strong>
        ISSUE OF PROJECT SANCTION ORDER<br/>
        FOR DESIGN AND DEVELOPMENT OF (INDICATE<br/>
        NAME OF PROJECT/PROTOTYPE AND THEIR QUANTITIES)
      </strong>
    </div>

    <br/><br/>

    <!-- BODY -->
    <div>
      <strong>1.</strong>
      Based on the response of <i>(type of the name of the company/firm)</i> to the EoI
      for <i>(indicate name of the project here)</i>, I am directed to issue this
      <strong>Project Sanction Order for Design and Development of Quantity</strong>
      <i>(indicate quantity of prototypes here)</i> prototypes of
      <i>(indicate the name of project/product here)</i> as per and within the Terms & Conditions
      of the Sanction as per the Memorandum of Agreement listed at Appendix A to this order.
    </div>

    <br/><br/><br/>

    <!-- SIGNATURE -->
    <div style="display:flex; justify-content:flex-end;">
      <div style="text-align:left;">
        (MY Name)<br/>
        Rank<br/>
        Appointment
      </div>
    </div>

    <br/><br/>

    <!-- FOOTER -->
    <div>
      <strong>Appendix:-</strong> Memorandum of Agreement
    </div>

    <br/>

    <div>
      <strong>Annexure:-</strong> List any addl annexures attached, if applicable
    </div>

    <br/>

    <div>
      <strong>Copy to:-</strong> List CC addressee here, as applicable to each SHQ
    </div>

  </div>
  `;
}